import {t} from "@lingui/core/macro";
import {css, StyleSheet} from "aphrodite";

import Link from "@khanacademy/wonder-blocks-link";
import {color} from "@khanacademy/wonder-blocks-tokens";
import {staticUrl} from "@khan/urls";

function KhanmigoHeader() {
    return (
        <header className={css(styles.khanmigoHeader)}>
            <Link href="https://khanmigo.ai">
                <img
                    src={staticUrl(
                        "/images/khanmigo/khanmigo_header_logo-2x.png",
                    )}
                    alt={t`Khanmigo: By Khan Academy`}
                    className={css(styles.khanmigoHeaderLogo)}
                />
            </Link>
        </header>
    );
}

const styles = StyleSheet.create({
    khanmigoHeader: {
        backgroundColor: color.white,
        textAlign: "center",
        width: "100%",
        boxShadow: `0px 1px 0px 0px ${color.offBlack16}`,
        // position and z-index get the boxShadow to display over the content
        // of the page
        position: "relative",
        zIndex: 1,
    },
    khanmigoHeaderLogo: {
        maxWidth: 186,
        margin: 18,
    },
});

export {KhanmigoHeader};
